import adminServices from 'services/admin/adminServices';

export const getAllSubjects = () => {
  return adminServices.showAllSubjects().then((res) => {
    return res.data.map((subject) => {
      subject.collections = subject.categories;
      delete subject.categories;
      return subject;
    });
  });
};

export const getSubjects = () => {
  return adminServices.showSubjects().then((res) => {
    return res.data.map((subject) => subject);
  });
};

export const getSchoolSubjects = () => {
  return adminServices.showSubjectsForSchool().then((res) => {
    return res.data;
  });
};

export const getAllGradeLevels = () => {
  return adminServices.showAllGrades().then((res) => {
    return res.data;
  });
};

export const getAllSkills = () => {
  return adminServices.showAllSkills().then((res) => {
    return res.data;
  });
};

export const getAllGrades = () => {
  return adminServices.showAllGrades().then((res) => {
    return res.data.map((element) => element);
  });
};

export const getAllUniverseCategories = () => {
  return adminServices.showAllUniverseCategories().then((res) => res.data);
};

export const createPremadePoll = (_, { answers, premade_id, question, status }) => {
  return adminServices.createPremadePoll({ premade_id, question, answers, status }).then(({ data }) => data);
};

export const editPremadePoll = (_, { poll_id, payload }) => {
  return adminServices.editPremadePoll(poll_id, payload).then(({ data }) => data);
};

export const deletePremadePoll = (_, poll_id) => {
  adminServices
    .deletePremadePoll(poll_id);
};


// WEBPACK FOOTER //
// ./src/app/store/actions/premades.js